import * as Login from "../login/loginStore";
import * as Trucks from '../trucks/store/truckStore'
import * as Units from '../units/store/unitStore'
import * as Companies from '../admin/store/companiesStore'
import { FeedbackState, reducer as FeedbackReducer } from "../admin/store/feedbackStore";
import { StatisticsState, reducer as StatisticsReducer } from '../statistics/store/statisticsStore'
import { RegisterUserState, reducer as RegisterUserReducer } from "../register/user/registerUserStore";
import { ModelState } from 'react-redux-form'
import { RegisterCompanyState, reducer as RegisterCompanyReducer } from "../register/company/registerCompanyStore";
import * as Settings from '../account/store/settingsStore';
import * as GiveFeedback from '../feedback/store/giveFeedbackStore';
import * as Restrictions from '../account/store/restrictionsStore'
import * as Notifications from '../notifications/notificationsStore';
import { CompanyState, reducer as VisibleCompanyReducer } from '../companies/store/companyStore';
import { FilterSettingsState, reducer as FilterSettingsReducer } from "../account/store/FilterSettingsStore";
import { WidgetSettingsState, reducer as WidgetSettingsReducer } from '../account/store/WidgetSettingsStore';
export interface ApplicationState {
  login: Login.LoginState;
  trucks: Trucks.TrucksState;
  units: Units.FreeUnitState;
  feedback: FeedbackState;
  registerUser: RegisterUserState;
  registerCompany: RegisterCompanyState;
  forms: ModelState,
  statistics: StatisticsState;
  companies: Companies.CompaniesState
  settings: Settings.SettingsState;
  giveFeedback: GiveFeedback.GiveFeedbackState;
  restrictions: Restrictions.RestrictionsState;
  notifications: Notifications.NotificationState;
  visibleCompanies: CompanyState;
  filterSettings: FilterSettingsState,
  widgetSettings: WidgetSettingsState
}

export const reducers = {
  login: Login.reducer,
  trucks: Trucks.reducer,
  units: Units.reducer,
  feedback: FeedbackReducer,
  registerUser: RegisterUserReducer,
  registerCompany: RegisterCompanyReducer,
  statistics: StatisticsReducer,
  companies: Companies.reducer,
  settings: Settings.reducer,
  giveFeedback: GiveFeedback.reducer,
  restrictions: Restrictions.reducer,
  notifications: Notifications.reducer,
  visibleCompanies: VisibleCompanyReducer,
  filterSettings: FilterSettingsReducer,
  widgetSettings: WidgetSettingsReducer
};


// WEBPACK FOOTER //
// ./src/store/index.ts